const SEED_FEEDBACK = [
  {
    id: 1,
    name: 'Aarav Rohit Sharma',
    date: '2026-08-19',
    type: 'Suggestion',
    typeId: 2,
    feedback: 'Could we have additional Sunday doubt-solving sessions for Corporate Law before the preliminary test series begins?',
    reply: 'Thank you for the suggestion. Special Sunday doubt clearance batches with Prof. Mehta have been scheduled starting this week.',
    replyBy: 'Prof. S. K. Mehta',
    replyOn: '2026-08-19 11:30 AM',
    instituteId: '1',
    instituteName: 'Tez Educational Trust',
    branchId: '1',
    branchName: 'Dadar',
    courseId: '1',
    courseName: 'CA Foundation',
    batchId: '1',
    batchName: 'Batch-A (Morning)',
  },
  {
    id: 2,
    name: 'Pooja Anand Deshmukh',
    date: '2026-08-18',
    type: 'Problem',
    typeId: 3,
    feedback: 'Facing issues while downloading Chapter 4 PDF notes from the mobile app syllabus tab. It throws a network timeout error.',
    reply: 'The file server cache has been updated. Please refresh your mobile app to access the notes seamlessly.',
    replyBy: 'Admin Office',
    replyOn: '2026-08-18 04:15 PM',
    instituteId: '1',
    instituteName: 'Tez Educational Trust',
    branchId: '2',
    branchName: 'Thane',
    courseId: '2',
    courseName: 'CS Executive',
    batchId: '2',
    batchName: 'Batch-CS-01',
  },
  {
    id: 3,
    name: 'Rohan K. Varma',
    date: '2026-08-17',
    type: 'Feedback',
    typeId: 1,
    feedback: 'The physics problem solving session conducted by Dr. Raman was extremely helpful for solving Advanced mechanics numericals.',
    reply: 'Glad to hear! We will continue conducting intensive problem solving seminars every weekend.',
    replyBy: 'Dr. V. Raman',
    replyOn: '2026-08-17 06:00 PM',
    instituteId: '3',
    instituteName: 'Tez Educational School',
    branchId: '3',
    branchName: 'Andheri',
    courseId: '3',
    courseName: 'JEE Advanced',
    batchId: '3',
    batchName: 'Super-30 (Intensive)',
  },
  {
    id: 4,
    name: 'Ananya S. Iyer',
    date: '2026-08-16',
    type: 'Problem',
    typeId: 3,
    feedback: 'Air conditioning in Room 204 was malfunctioning during yesterday afternoon lecture.',
    reply: '',
    replyBy: '',
    replyOn: '',
    instituteId: '2',
    instituteName: 'Tolani College Of Commerce',
    branchId: '1',
    branchName: 'Dadar',
    courseId: '4',
    courseName: 'NEET UG',
    batchId: '4',
    batchName: 'Med-Achievers',
  },
]

function getStoredFeedback() {
  try {
    const raw = localStorage.getItem('cloud_feedback_records')
    if (!raw) {
      localStorage.setItem('cloud_feedback_records', JSON.stringify(SEED_FEEDBACK))
      return SEED_FEEDBACK
    }
    return JSON.parse(raw)
  } catch {
    return SEED_FEEDBACK
  }
}

function saveStoredFeedback(list) {
  try {
    localStorage.setItem('cloud_feedback_records', JSON.stringify(list))
    window.dispatchEvent(new Event('cloud-feedback-updated'))
  } catch (err) {
    console.error('Failed to save feedback records to localStorage', err)
  }
}

export async function fetchFeedbackList(filters = {}, sortBy = 'date', sortOrder = 'desc') {
  await new Promise((resolve) => setTimeout(resolve, 80))
  let list = getStoredFeedback()

  // Filter: Institute
  if (filters.company && filters.company !== 'All') {
    list = list.filter((f) => f.instituteName === filters.company)
  }
  // Filter: Branch
  if (filters.branch && filters.branch !== 'All') {
    list = list.filter((f) => f.branchName === filters.branch)
  }
  // Filter: Course
  if (filters.course && filters.course !== 'All') {
    list = list.filter((f) => f.courseName === filters.course)
  }
  // Filter: Batch
  if (filters.batch && filters.batch !== 'All') {
    list = list.filter((f) => f.batchName === filters.batch)
  }
  // Filter: Type
  if (filters.type && filters.type !== 'All' && filters.type !== '0') {
    list = list.filter((f) => String(f.typeId) === String(filters.type) || f.type.toLowerCase() === filters.type.toLowerCase())
  }
  // Filter: Date Range
  if (filters.fromDate) {
    list = list.filter((f) => f.date >= filters.fromDate)
  }
  if (filters.tillDate) {
    list = list.filter((f) => f.date <= filters.tillDate)
  }

  // Search
  if (filters.searchText) {
    const q = filters.searchText.toLowerCase().trim()
    list = list.filter(
      (f) =>
        (f.name || '').toLowerCase().includes(q) ||
        (f.feedback || '').toLowerCase().includes(q) ||
        (f.reply || '').toLowerCase().includes(q) ||
        (f.type || '').toLowerCase().includes(q)
    )
  }

  // Sorting
  list.sort((a, b) => {
    let valA = a[sortBy] ?? ''
    let valB = b[sortBy] ?? ''
    if (typeof valA === 'string') {
      return sortOrder === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA)
    }
    return sortOrder === 'asc' ? valA - valB : valB - valA
  })

  return {
    records: list,
    totalRecords: list.length,
  }
}

export async function getFeedbackById(id) {
  await new Promise((resolve) => setTimeout(resolve, 50))
  const list = getStoredFeedback()
  const found = list.find((f) => f.id === parseInt(id, 10))
  if (!found) throw new Error(`Feedback not found with ID ${id}`)
  return found
}

export async function saveFeedbackReply(id, replyText, replyBy = 'Admin Office') {
  await new Promise((resolve) => setTimeout(resolve, 100))
  const list = getStoredFeedback()
  const targetId = parseInt(id, 10)

  const formattedTimestamp = new Date().toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }) + ' ' + new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })

  const updatedList = list.map((item) => {
    if (item.id === targetId) {
      return {
        ...item,
        reply: replyText.trim(),
        replyBy: replyBy,
        replyOn: formattedTimestamp,
        updatedAt: new Date().toISOString(),
      }
    }
    return item
  })

  saveStoredFeedback(updatedList)
  return updatedList.find((f) => f.id === targetId)
}
